/**
 * Enum nội dung hạch toán lương
 * NNLINH 14.11.2022
 */
export default {
  // Hạch toán toàn bộ lương phát sinh
  ExpenseAll: 1,

  // Hạch toán trên số lương đã trừ các khoản bảo hiểm, kinh phí công đoàn, thuế TNCN
  ExpenseSalary: 2,

  // Hạch toán chi phí lương cho Bảo hiểm
  ExpenseInsurance: 3,

  // Hạch toán Kinh phí công đoàn

  ExpenseLaborFee: 4,

  // Hạch toán Thuế TNCN
  ExpenseTax: 5,
};
